import { Grid, Typography } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import TextField from "@mui/material/TextField";
import * as React from "react";
import { useEffect, useState } from "react";
import { Button, useGetOne, useRefresh } from "react-admin";
import sendRequest from "../../dataProvider/sendRequest";
import CustomButtonCancel from "../../unit/CustomButtonCancel";
import CustomButtonSubmit from "../../unit/CustomButtonSubmit";
import HeaderLabelTitle from "../../unit/HeaderLabelTitle";
import UploadFile from "../../unit/UploadFile";
import CustomSelect from "../../unit/forms/CustomSelect";
import useNotify from "../../unit/useNotify";
import DialogApplicationBaseInfo from "../DialogApplicationBaseInfo";
import CustomDialogTitle from "../../unit/CustomDialogTitle";
import CustomApplicationDialogTitle from "./CustomApplicationDialogTitle";

const NoAccountText = ({ ...props }) => {
  const subType = props.subType;
  const accountToOpen = props.accountToOpen;
  const accountTypeShow = props.accountTypeShow;

  if (
    accountTypeShow == "no_account" &&
    subType != "account" &&
    accountToOpen != "yes"
  ) {
    return (
      <Typography variant="body1" sx={{ color: "red" }} gutterBottom>
        New Member/Customer. Review application to open account.
      </Typography>
    );
  }
  return <></>;
};
const CustomExistingAccount = ({ ...props }) => {
  const [accountTypeShow, setAccountTypeShow] = React.useState("");
  const { subType, accountToOpen } = props;

  const defaultAccountTypeOption = [
    { label: "Savings", value: "savings" },
    { label: "Checking", value: "checking" },
    { label: "No Account", value: "no_account" },
  ];

  const handleAccountType = (e) => {
    setAccountTypeShow(e.target.value);
  };

  // console.log("accountTypeShow==>", accountTypeShow);
  return (
    <Grid container>
      <Grid item xs={5}>
        <HeaderLabelTitle title="Existing Account" />
      </Grid>
      <Grid item xs={5}>
        <CustomSelect
          fullWidth={true}
          variant="outlined"
          id="existing_account_type"
          name="existing_account_type"
          optionlist={defaultAccountTypeOption}
          value={accountTypeShow}
          onChange={handleAccountType}
        />
        {accountTypeShow == "no_account" && (
          <NoAccountText
            subType={subType}
            accountToOpen={accountToOpen}
            accountTypeShow={accountTypeShow}
          />
        )}
        {accountTypeShow != "" && accountTypeShow != "no_account" && (
          <>
            <TextField
              fullWidth
              type="text"
              variant="outlined"
              id="existing_account_number"
              name="existing_account_number"
              placeholder="Existing Account Number"
            />
            <TextField
              fullWidth
              type="text"
              variant="outlined"
              id="existing_account_years"
              name="existing_account_years"
              placeholder="Existing Account History In Years"
            />
          </>
        )}
      </Grid>
      <Grid item xs={2}></Grid>
    </Grid>
  );
};

const FieldText = ({ ...props }) => {
  const data = props.data;
  return (
    <Grid item xs={12} sx={{ mb: 2 }}>
      <Typography variant="h6" gutterBottom>
        {data.title}
      </Typography>
    </Grid>
  );
};

const FieldCheckBox = ({ ...props }) => {
  const data = props.data;
  return (
    <Grid sx={{ mb: 2 }} container>
      <Grid item xs={5} sx={{ pt: 1 }}>
        <HeaderLabelTitle
          title={data.title}
          required={data.required == "Optional" ? false : true}
        />
      </Grid>
      <Grid item xs={5}>
        <Checkbox
          name={data.id}
          required={data.required == "Optional" ? false : true}
        />
      </Grid>
      <Grid item xs={2}></Grid>
    </Grid>
  );
};

const FieldInput = ({ ...props }) => {
  const data = props.data;
  return (
    <Grid sx={{ mb: 2 }} container>
      <Grid item xs={5} sx={{ pt: 1 }}>
        <HeaderLabelTitle
          fullWidth
          title={data.title}
          required={data.required == "Optional" ? false : true}
        />
      </Grid>
      <Grid item xs={5}>
        <TextField
          fullWidth
          type="text"
          variant="outlined"
          id={data.id}
          name={data.id}
          required={data.required == "Optional" ? false : true}
        />
      </Grid>
      <Grid item xs={2}></Grid>
    </Grid>
  );
};

const FieldSelect = ({ ...props }) => {
  const data = props.data;
  let optionAttrs: { label: string; value: string }[] = [];
  if (data.optionlist) {
    optionAttrs = data.optionlist.map((option: any) => ({
      label: option,
      value: option,
    }));
  }
  const [selectedValue, setSelectedValue] = React.useState("");
  const handleChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    setSelectedValue(event.target.value as string);
  };
  return (
    <Grid sx={{ mb: 2 }} container>
      <Grid item xs={5} sx={{ pt: 1 }}>
        <HeaderLabelTitle
          title={data.title}
          required={data.required == "Optional" ? false : true}
        />
      </Grid>
      <Grid item xs={5}>
        <CustomSelect
          fullWidth={true}
          variant="outlined"
          id={data.id}
          name={data.id}
          optionlist={optionAttrs}
          required={data.required == "Optional" ? false : true}
          value={selectedValue}
          onChange={handleChange}
        />
      </Grid>
      <Grid item xs={2}></Grid>
    </Grid>
  );
};

const FieldTextArea = ({ ...props }) => {
  const data = props.data;
  return (
    <Grid sx={{ mb: 2 }} container>
      <Grid item xs={5} sx={{ pt: 1 }}>
        <HeaderLabelTitle
          title={data.title}
          required={data.required == "Optional" ? false : true}
        />
      </Grid>
      <Grid item xs={5}>
        <TextField
          required={data.required == "Optional" ? false : true}
          id={data.id}
          name={data.id}
          placeholder={data.title}
          multiline={true}
          minRows={3}
          fullWidth
          variant="outlined"
        />
      </Grid>
      <Grid item xs={2}></Grid>
    </Grid>
  );
};

const FieldUploadFiles = ({ ...props }) => {
  const data = props.data;
  const appId = props.appId;
  return (
    <Grid sx={{ mb: 2 }} container>
      <Grid item xs={5} sx={{ pt: 1 }}>
        <HeaderLabelTitle title={data.title} />
      </Grid>
      <Grid item xs={5}>
        <UploadFile appId={appId} />
      </Grid>
      <Grid item xs={2}></Grid>
    </Grid>
  );
};

export default function CustomInitiateReviewFormDialog({ ...props }) {
  const { successNotify, errorNotify, infoNotify } = useNotify();
  const { appId, record } = props;
  const [open, setOpen] = React.useState(false);
  const refresh = useRefresh();
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    refresh();
  };

  const defaultMlaStatusOption = [
    { label: "Active Duty", value: "Active Duty" },
    { label: "AD Family", value: "AD Family" },
    { label: "None", value: "None" },
  ];

  const requrl = "product/reviewIterms/" + appId;

  const { data, error } = useGetOne(requrl, { id: record.iProductId });
  const reviewList = data?.reviewList;
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!isLoading && !data) {
      setIsLoading(true);
      refresh();
    }
    if (data) {
      setIsLoading(false);
    }
  }, [data]);

  return (
    <React.Fragment>
      <Button
        id="btn-application-initiate"
        label="Initiate"
        variant="contained"
        size="medium"
        color="primary"
        sx={{ width: "120px", ml: "10px" }}
        onClick={handleClickOpen}
      />
      <Dialog
        key={`initiateReviewDialog_` + appId}
        id="dialog-application-initiate"
        open={open}
        onClose={handleClose}
        fullWidth={true}
        maxWidth="lg"
        PaperProps={{
          component: "form",
          onSubmit: async (event: React.FormEvent<HTMLFormElement>) => {
            event.preventDefault();
            const formData = new FormData(event.currentTarget);
            var uploadFileId = document.getElementById("uploadFileId") as any;
            if (uploadFileId) {
              formData.append("uploadFileIds", uploadFileId.value);
            }
            const formJson = Object.fromEntries((formData as any).entries());
            const notes = formJson.notes;

            const reqUrl = `applications/actions/sendToInitialReview`;
            const response = await sendRequest(reqUrl, {
              id: appId,
              data: formJson,
            });

            if (response && response.status == 200) {
              successNotify("Data saved successfully");
              if (props.cb) {
                props.cb("Initial Review");
              }
              handleClose();
            } else {
              errorNotify(response?.message || "Data not saved!");
            }
          },
        }}
      >
        <DialogTitle
          sx={{
            fontWeight: "bold",
            mb: 2,
            borderBottom: "1px solid #e5e5e5",
            color: "#465384",
            textTransform: "uppercase",
          }}
        >
          <CustomApplicationDialogTitle record={record} subTitle="Initiate" />
        </DialogTitle>
        <DialogContent>
          <DialogContentText></DialogContentText>
          <DialogApplicationBaseInfo appId={appId} record={record} />
          <Grid
            container
            sx={{ mb: 2, pb: 2 }}
            key={`initiateReviewDialogGrid_` + appId}
          >
            {reviewList &&
              reviewList.map((items: any) => {
                const uniqueKey = Math.random().toString(36).substring(2, 15);
                if (items.type == "text") {
                  return <FieldText data={items} key={uniqueKey} />;
                } else if (items.type == "checkbox") {
                  return <FieldCheckBox data={items} key={uniqueKey} />;
                } else if (items.type == "input") {
                  return <FieldInput data={items} key={uniqueKey} />;
                } else if (items.type == "select") {
                  return <FieldSelect data={items} key={uniqueKey} />;
                } else if (items.type == "textarea") {
                  return <FieldTextArea data={items} key={uniqueKey} />;
                } else if (items.type == "accountGroup") {
                  return (
                    <CustomExistingAccount
                      subType={record.subType}
                      accountToOpen={record.account_to_open}
                      key={uniqueKey}
                    />
                  );
                } else if (items.type == "many_uploadfiles") {
                  return (
                    <FieldUploadFiles
                      data={items}
                      appId={appId}
                      key={uniqueKey}
                    />
                  );
                }
              })}
          </Grid>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "space-between" }}>
          <CustomButtonCancel onClick={handleClose} />
          <CustomButtonSubmit
            label="Initiate"
            sx={{ textTransform: "uppercase", width: "120px" }}
          />
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
